import { useContext } from "react"
import { TableColumnResizeContext } from "./context"
import { TableElement, TableProps } from "./table";

export const initialResizeSpec: ResizeSpec = {}
export type ResizeSpec =  Record<string, number | undefined>

export type Resized = {
    onResize: (key:string, defaultSize?:string|number, than?:()=>void)=>(e:MouseEvent, {size, node}) => void,
    width: number | undefined,
    resizable?: boolean,
}

export const useResize = <E extends TableElement>(props: TableProps<E>) => {

    const ctx = useContext(TableColumnResizeContext)

    const resize:ResizeSpec = ctx.get() ?? {}

    const onResize = (key:string, defaultSize:string|number=150,  than?)=>(e:MouseEvent, args:{node, size:{width:number}}) => {
        const { size, node } = args
        const _defaultSize = typeof defaultSize === 'string' ? parseInt(defaultSize) : defaultSize
        const defaultWidth = node?.offsetParent?.clientWidth || defaultSize
        ctx.set((state) => {
            state[key] = size.width > _defaultSize ? size.width : defaultWidth 
        })
        than()
    }

    return {
        resize,
        onResize
    }

}